import { hasLanguage } from 'ha/helpers/routes/hasLanguage';

export default routes => (location, cbLang) => {
  if (hasLanguage(location)) {
    return cbLang(null, routes);
  }

  return cbLang(null, []);
};
